import { createLoader } from '@meteor/data-hooks';
import { endOfDay, startOfDay, subDays } from 'date-fns';
import { useMemo, useState } from 'react';
import { useInterval } from 'react-use';
import { withAuth } from '../../user';
import { usageClient } from '../client';

export let usageLoader = createLoader({
  name: 'usage',
  fetch: (i: {
    organizationId: string;
    entities: {
      type: string;
      id: string;
    }[];
    from: Date;
    to: Date;
    interval: {
      unit: 'day' | 'hour';
      count: number;
    };
  }) => withAuth(() => usageClient.usage.timeline(i)),
  mutators: {}
});

export let useUsage = (opts: {
  organizationId: string | null;
  entities: {
    type: string;
    id: string;
  }[];

  from?: number;
  interval?: {
    unit: 'day' | 'hour';
    count: number;
  };
}) => {
  let [from, setFrom] = useState(() =>
    startOfDay(subDays(new Date(), Math.abs(opts.from || 7)))
  );
  let [to, setTo] = useState(() => endOfDay(new Date()));
  let [now, setNow] = useState(() => new Date());
  let toNormalized = useMemo(() => (to > now ? now : to), [to, now]);

  useInterval(() => {
    setNow(new Date());
  }, 1000 * 60);

  let [interval, setInterval] = useState(
    () => opts.interval || { unit: 'hour' as const, count: 1 }
  );

  let usage = usageLoader.use(
    opts.organizationId && opts.entities.length
      ? {
          organizationId: opts.organizationId,
          entities: opts.entities,
          from,
          to: toNormalized,
          interval
        }
      : null
  );

  return [
    {
      ...usage,
      data: usage.data?.map(d => ({
        ...d,
        entries: d.entries.sort((a, b) => a.ts.getTime() - b.ts.getTime())
      }))
    },
    {
      from,
      setFrom,

      to,
      setTo,

      interval,
      setInterval
    }
  ] as const;
};
